/*
 * Copyright (C) 2019 - present Marek Kuzora - All Rights Reserved.
 */


import Base from 'shared/client/behavior/base';

import SelectAlgorithm from 'shared/enum/select.algorithm';
import SelectStyle from 'shared/enum/select.style';
import SelectType from 'shared/enum/select.type';


export default class extends Base
{
  canNavigate ()
  {
    return false;
  }


  canSelect ()
  {
    return true;
  }


  getSelectAlgorithm ()
  {
    return SelectAlgorithm.Multi
  }


  getSelectStyle ()
  {
    return SelectStyle.Directed;
  }


  getSelectType ()
  {
    return SelectType.Zone;
  }


  getSelectValueCount (current, target, galaxy)
  {
    return (current.getUser().getID() === target.getUser().getID()) ? 2 : 1;
  }


  getSelectRange ()
  {
    return 1;
  }


  getSelectInitialTargets (current, galaxy)
  {
    let targets = {};

    for (const direction of current.getZone().getDirections().getOutgoing())
    {
      const directionToID = current.getNeighbors().getLocations()[direction].getID();

      targets[directionToID] = 1;
    }

    for (const direction of current.getZone().getDirections().getIncomming())
    {
      const directionToID = current.getNeighbors().getLocations()[direction].getID();

      targets[directionToID] = 2;
    }

    return targets;
  }


  isPaneCollapsed ()
  {
    return true;
  }


};
